import { Link } from 'react-router-dom';

const STATS = [
  { value: '12,000+', label: '收录影视' },
  { value: '8 大', label: '分类频道' },
  { value: '1080P', label: '高清画质' },
  { value: '每日', label: '持续更新' },
];

export default function SiteIntro() {
  return (
    <section className="w-full bg-primary-900">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-14 items-center">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-label font-medium text-accent-400">
              <i className="ri-leaf-line" />
              关于神马影视
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-3xl font-extrabold text-background-50 leading-snug">
              好故事，值得被更多人看见
            </h2>
            <p className="mt-4 text-sm md:text-base text-background-200 leading-relaxed">
              神马影视是一个提供高清电影、电视剧免费在线观看与影视资讯浏览的综合影视平台。
              从院线大片到热播剧集，从行业观察到幕后专访，我们把观众真正想看的内容整理在一起，
              让「找一部好片」这件事变得简单又愉快。
            </p>
            <div className="mt-7 flex flex-wrap gap-3">
              <Link
                to="/movie"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-semibold text-foreground-950 hover:bg-accent-400 transition-colors"
              >
                <i className="ri-play-fill text-lg" />
                开始观影
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 px-5 py-2.5 text-sm font-medium text-background-50 hover:bg-background-50/10 transition-colors"
              >
                了解更多
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3 md:gap-4">
            {STATS.map((stat) => (
              <div
                key={stat.label}
                className="rounded-lg bg-primary-800/70 border border-primary-700 p-5"
              >
                <p className="font-heading text-2xl md:text-3xl font-extrabold text-accent-400">{stat.value}</p>
                <p className="mt-1.5 text-sm text-background-200">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}